import { render, staticRenderFns } from "./RoleLayer.vue?vue&type=template&id=1c04eb53&"
import script from "./RoleLayer.vue?vue&type=script&lang=js&"
export * from "./RoleLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports